import { createModule, constants } from "./redux-acron";
import api from "services/api";
import { handlerWrapper, handlerEffects } from "../utils";
import configuration from "../config/configurations"

/**
 * Alerts Module
 * reducer/sagas/actions
 *
 * TODO: Agregar todos los handlers y effects para los diferentes indicadores
 */
export default createModule({
  name: "configuration",
  modelName: "configuration",

  state: {
    error: {},
    clusters: [],
    logicalLocations: [],
    geoLocations: [],
    criticalMoments: [],
    data: [],
    loadingData: [],
    loadingConfiguration: true
  },

  handlers: {
    getConfiguration: (state, { payload }) => {
      return state.merge({
        loadingConfiguration: false,
        data: configuration[0]
      });
    },
    getClusters: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("clusters", state, status, payload);
    },
    getLogicalLocations: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("logicalLocations", state, status, payload);
    },
    getGeoLocations: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("geoLocations", state, status, payload);
    },
    getCriticalMoments: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("criticalMoments", state, status, payload);
    },
  },

  effects: {
    // Get Clusters info
    getClusters: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.clusters,
          null,
          actions.getClusters
        );
      }
    },
    // Get Logical Locations info
    getLogicalLocations: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.logicalLocations,
          null,
          actions.getLogicalLocations
        );
      }
    },
    // Get Geo Location info
    getGeoLocations: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.geoLocations,
          null,
          actions.getGeoLocations
        );
      }
    },
    // Get Geo Location info
    getCriticalMoments: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.criticalMoments,
          null,
          actions.getCriticalMoments
        );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/ConfigurationModule.js